import {initializeApp} from "firebase/app"
import { getFirestore } from "firebase/firestore";
import { collection, getDocs } from "firebase/firestore";
import {getAuth , GoogleAuthProvider} from "firebase/auth";
import firebase from "firebase/compat/app"
import {getStorage} from "firebase/storage"
firebase.initializeApp

const firebaseConfig ={
  apiKey: "AIzaSyD2CFY9th3zoMS91gVShuDAQiouGjdN5pw",
  authDomain: "trip-6aeb9.firebaseapp.com",
  projectId: "trip-6aeb9",
  storageBucket: "trip-6aeb9.appspot.com",
  messagingSenderId: "718749545113",
  appId: "1:718749545113:web:102da8bc4c9ac71988fe08"
  // apiKey:process.env.REACT_APP_ApiKey,
  // authDomain:process.env.REACT_APP_AuthDomain,
  // projectId:process.env.REACT_APP_ProjectId,
  // storageBucket:process.env.REACT_APP_StorageBucket,
  // messagingSenderId:process.env.REACT_APP_MessagingSenderId,
  // appId:process.env.REACT_APP_AppId
};

//console.log(firebaseConfig)

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
export const storage = getStorage(app);
const provider = new GoogleAuthProvider();


export {app,auth,provider};
export default db;